"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenStax Highlights API
 * The highlights API for OpenStax.  Requests to this API should include `application/json` in the `Accept` header.  The desired API version is specified in the request URL, e.g. `[domain]/highlights/api/v0/highlights`. While the API does support a default version, that version will change over time and therefore should not be used in production code!
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function TextPositionSelectorFromJSON(json) {
    return TextPositionSelectorFromJSONTyped(json, false);
}
exports.TextPositionSelectorFromJSON = TextPositionSelectorFromJSON;
function TextPositionSelectorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'start': json['start'],
        'end': json['end'],
        'type': json['type'],
    };
}
exports.TextPositionSelectorFromJSONTyped = TextPositionSelectorFromJSONTyped;
function TextPositionSelectorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start': value.start,
        'end': value.end,
        'type': value.type,
    };
}
exports.TextPositionSelectorToJSON = TextPositionSelectorToJSON;
